// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageNoImageImage_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.37294 14.5948L2.4336 15.6554L4.08476 14.0043L15.0001 14.0048L15 3.08902L15.8686 2.22039L14.8084 1.16016L1.37294 14.5948ZM10.843 3.00425H1V12.8472L6.03872 7.80851L5.5 7.10191L2.5 11.0368V4.50426H9.34298L10.843 3.00425ZM8.70238 11.3023L7.87369 10.2153L10.3597 7.72935C10.5864 7.95935 10.9015 8.10193 11.25 8.10193C11.9403 8.10193 12.5 7.54229 12.5 6.85193C12.5 6.50348 12.3574 6.18833 12.1274 5.96163L13.5 4.58902V12.5043L10.5001 9.50481L8.70238 11.3023Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.70421 21.8021L4.11529 23.2132L7.23773 20.0908H22V5.32849L23.9143 3.41421L22.5001 2L21.8963 2.60372L21.8995 2.60686L2.70421 21.8021ZM12.6174 16.3334L11.9035 15.4249L16.5645 10.764C16.821 10.9689 17.1462 11.0914 17.5 11.0914C18.3284 11.0914 19 10.4198 19 9.59138C19 9.23757 18.8775 8.91237 18.6726 8.65588L20 7.32849V18.0906L15.5 13.5924L12.6174 16.3334Z" class="svg-bg"/>
  <path d="M17.5865 4.09138H2V19.6779L9.41729 12.2606L8.5 11.0932L4 16.8204V6.09138H15.5865L17.5865 4.09138Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.0068 25.9893L3.91138 28.0847L5.32559 29.499L8.83523 25.9893H27.9999V6.8246L30.7814 4.04312L29.3672 2.62891L26.0068 5.98932H25.9988L23.9988 7.98932H24.0068L22.0068 9.98933C22.0045 9.98933 22.0022 9.98932 21.9999 9.98932L21.9988 9.98932L19.9999 11.9882V11.9893C19.9999 11.9916 20 11.9939 20 11.9962L13.9502 18.0459L13.9468 18.0413L5.99878 25.9893H6.0068ZM15.1411 19.6834L16.0526 20.9367L19.9999 16.9893L25.9999 23.8465V8.82461L23.769 11.0555C23.9165 11.3343 23.9999 11.652 23.9999 11.9893C23.9999 13.0939 23.1045 13.9893 21.9999 13.9893C21.6627 13.9893 21.3449 13.9058 21.0662 13.7584L15.1411 19.6834Z" class="svg-bg"/>
  <path d="M5.99995 7.98932H21.1704L23.1704 5.98932H3.99995V25.1597L12.7559 16.4038L10.9999 13.9893L5.99995 21.0824V7.98932Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M60.9914 2.00879L3.00867 59.9915L5.83709 62.82L10.6567 58.0003H62V8.00033H60.6567L63.8198 4.83721L60.9914 2.00879ZM56.6567 12.0003L51.5178 17.1392C53.0218 18.2295 54 20.0007 54 22.0003C54 25.314 51.3137 28.0003 48 28.0003C46.0004 28.0003 44.2292 27.0221 43.1389 25.5181L30.0384 38.6187L35.9815 45.9295L45 35.0003L58 51.0003V12.0003H56.6567ZM6 12.0003H45.3433L49.3433 8.00033H2V55.3436L24.9654 32.3782L21 27.5003L6 45.6566V12.0003Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageNoImageImage is a generated icon component.
 */
let IconImageNoImageImage = IconImageNoImageImage_1 = class IconImageNoImageImage extends IconBaseElement {
    render() {
        return html `${IconImageNoImageImage_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageNoImageImage.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconImageNoImageImage = IconImageNoImageImage_1 = __decorate([
    customElement('zui-icon-image-no-image-image')
], IconImageNoImageImage);
export { IconImageNoImageImage };
